import ComponentStatus from './ComponentStatus';

export default ComponentStatus;
